import React from 'react';
import PropTypes from 'prop-types';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';
import CdsPointsPaymentSummary from './CdsPointsPaymentSummary';

/** The server records informational earnings; CDS credits the actual account. */
export default function CdsPointsRewards({
  earning,
  purchaseStatus,
  usesCdsPoints,
  accountId,
  token,
}) {
  const { brand } = useWhitelabelEnvs();
  const { CDS_POINTS_EARNING_ENABLED } = useWhitelabelFeatures();
  if (
    brand !== 'cds' ||
    CDS_POINTS_EARNING_ENABLED !== true ||
    purchaseStatus !== 'completed' ||
    usesCdsPoints ||
    earning?.status !== 'finalized_estimate' ||
    earning.eligible !== true ||
    !Number.isFinite(Number(earning.points)) ||
    Number(earning.points) <= 0
  )
    return null;

  return (
    <CdsPointsPaymentSummary
      variant="earned"
      pointsAmount={earning.points}
      accountId={accountId}
      token={token}
    />
  );
}

CdsPointsRewards.propTypes = {
  earning: PropTypes.shape({
    status: PropTypes.string,
    eligible: PropTypes.bool,
    points: PropTypes.string,
  }),
  purchaseStatus: PropTypes.string,
  usesCdsPoints: PropTypes.bool,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  token: PropTypes.string,
};
CdsPointsRewards.defaultProps = {
  earning: null,
  purchaseStatus: null,
  usesCdsPoints: false,
  accountId: null,
  token: null,
};
